<template>
  <section class="section-content">
    <slot />
  </section>
</template>

<script>
export default {
  name: 'SectionContent'
}
</script>

<style lang="sass" scoped>
.section-content
  margin: 5rem 4rem
</style>
